// Fecha local del dispositivo en Y-m-d. No usar toISOString(): devuelve la fecha en UTC y, pasada
// la medianoche en España, sigue diciendo el día anterior.
export function todayLocal(): string {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');

    return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
}
